export default "__VITE_ASSET__b79de7b6__"